import createClient from '@economic/http-client';
export { createJsonPatchOperation } from '@economic/http-client';

export default createClient(`${process.env.ECONOMIC_PATH}/WebServices/EconomicEventWebService.asmx`);
